export default "__VITE_ASSET__DDnomYHr__"